import axios from 'axios';
import { useCallback, useEffect, useState } from 'react'
import {node_assessment_should_show } from '../../../assets/jss/incept-sustainability-variables';


const useAssessmentHandler = () => {
  const [showAssessments, setShowAssessments] = useState<boolean>(false);
  const token = localStorage.getItem('token');
  const authStr = 'Bearer ' + token;

  const fetchShouldShowAssessments = useCallback(async () => {
    const response = await axios.get(`${node_assessment_should_show}`, {
        headers: {
            Authorization: authStr
        }
    });
    setShowAssessments(response.data);  
   }, []);

   useEffect(() => {
    if (!token) return;
    fetchShouldShowAssessments();
   }, [fetchShouldShowAssessments, token]);

   return {showAssessments};
}

export default useAssessmentHandler;